import theme__ from '../../../common/ThemeSettings';
import React, { useEffect, useState, useMemo } from 'react'
import { useLocation } from "react-router-dom";
import { useParams } from 'react-router-dom';
import Axios from "axios";
export default function ReportPreview() {
    const { survey_id, ss_id, srid, isPreview, device } = useParams();
    const [preview, setPreview] = useState(0);
    const [deviceType, setDeviceType] = useState('Desktop');
    const [stage_array, setStageArray] = useState([]);
    const [stage_data, setStageData] = useState({});

    const [theme, setTheme] = useState(-1);
    const [themeSet, setThemeSet] = useState([1]);
    const [logoImage, setLogoImage] = useState('');

    const [selectStage, setSelectStage] = useState('');
    const [selectedOption, setSelectedOption] = useState('');

    

    const location = useLocation();
    const currentUrl = location.pathname;
    const parts = currentUrl.split('/');
    const currentStageValue = parts[3];


    const [reloadIframe, setReloadIframe] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            console.clear(); // Clear console before reloading iframe
            console.log('Console cleared. Reloading iframe...');
            setReloadIframe(true);
        }, 2000);
        
        return () => clearTimeout(timeout);
    }, []);

    useEffect(() => {
        //alert(survey_id)
        console.log(process.env.REACT_APP_NODE_API_URL)
        Axios.post(process.env.REACT_APP_NODE_API_URL + "/frnt/getStages", {
            survey_id: survey_id,
        }).then((response) => {
            if (response.data.statusCode == 200) {
                console.log(response.data.data);    
                var data = response.data.data;
                let stage_array_ = [];
                Object.keys(data).map((key, index) => {
                    let data_ = JSON.parse(data[key].su_stage_formulas);
                    console.log("data_",data_);
                    let data__ = {};
                    data__['compare'] = data_['compare'];
                    data__['from'] = data_['from'];
                    data__['to'] = data_['to'];
                    if(key==ss_id){
                        setStageData(JSON.stringify(data__));
                        console.log("---",JSON.stringify(data__));
                    }
                    
                    let stage_name = JSON.parse(data[key].su_stage_name);
                    stage_array_.push(stage_name[22]);
                });
                setStageArray(stage_array_);
            }

        });
        
    }, [survey_id]);

    useEffect(() => {
        setPreview(isPreview);
    }, [isPreview]);

    useEffect(() => {
        setDeviceType(device);
    }, [device]);

    useEffect(() => {
        
        setSelectStage(currentStageValue);
        setSelectedOption(stage_array[currentStageValue]);
        // const storedStage = localStorage.getItem('selectedStage');
        // if (storedStage && stage_array.hasOwnProperty(storedStage)) {
        //     //setSelectStage(storedStage);
        //     //setSelectedOption(stage_array[storedStage]);
        // }
    }, [stage_array, currentStageValue ])
    const onHandleChange = (e) => {
        //alert(e.target.value)
        // const selectedStage = e.target.value;
        // if(selectedStage){
        //     const selectedStage = e.target.value;
        //     window.location.href = `/report-preview/${survey_id}/${selectedStage}/${srid}/1/${deviceType?deviceType:'Desktop'}`;
        // }else{
        //     //const selectedStage = 0;
        //     localStorage.setItem('selectedStage', "");
        //     window.location.href = `/report-preview/${survey_id}/${0}/${srid}/1/${deviceType?deviceType:'Desktop'}`;
        // }
        window.location.href = `/report-preview/${survey_id}/${e.target.value}/${srid}/1/${deviceType ? deviceType : 'Desktop'}`;
    };

    // useEffect(() => {
    //     if (surveyDetail.length > 0) {
    //         setTheme([surveyDetail[0].theme_selected]);

    //     }
    // }, [surveyDetail])

    //Effects
    useEffect(() => {
        if (theme == 0 || theme == null) {
            setLogoImage('https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/a0e0d1d3-f39b-4a07-b7ec-8bea0c47c919_1705681254869_download.png');
        } else if (theme >= 1) {
            setLogoImage('https://survey-bis.s3.ap-south-1.amazonaws.com/logo/' + theme + '.svg');
        }
        setThemeSet(theme__[theme]);
    }, [theme]);

    return (
        <>
            {(preview == 1) && (
                <>
                <div dangerouslySetInnerHTML={{ __html: "<style type='text/css'> :root { --font-family: " + themeSet['--font-family'] + "; --da-primary: " + themeSet['--da-primary'] + " !important; --da-secondary: " + themeSet['--da-secondary'] + " !important; --progress-1: " + themeSet['--progress-1'] + " !important; --progress-2: " + themeSet['--progress-2'] + " !important; --progress-3: " + themeSet['--progress-3'] + " !important; --progress-4: " + themeSet['--progress-4'] + " !important; --progress-5: " + themeSet['--progress-5'] + " !important; } </style>" }} />
                <div className="preview-bar d-flex justify-content-between align-items-center">
                    <div className="device-icons">
                        <div className="radio-btn-screen d-inline-flex align-items-center justify-content-center">
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="screenSize" id="Desktop" defaultValue="Desktop" onClick={() => setDeviceType('Desktop')}
                                    defaultChecked />
                                <label className="form-check-label" htmlFor="Desktop" title="Desktop">
                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12 17H21C22.1046 17 23 16.1046 23 15V5C23 3.89543 22.1046 3 21 3H3C1.89543 3 1 3.89543 1 5V15C1 16.1046 1.89543 17 3 17H12ZM12 17V21M12 21H16M12 21H8"
                                            stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" />
                                    </svg>


                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="screenSize" id="Tablet" defaultValue="Tablet" onClick={() => setDeviceType('Tablet')} />
                                <label className="form-check-label" htmlFor="Tablet" title="Tablet">
                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM6 1.75H18V0.25H6V1.75ZM19.25 3V21H20.75V3H19.25ZM4.75 21V3H3.25V21H4.75ZM18 22.25H6V23.75H18V22.25ZM11 19.75H13V18.25H11V19.75ZM3.25 21C3.25 22.5188 4.48122 23.75 6 23.75V22.25C5.30964 22.25 4.75 21.6904 4.75 21H3.25ZM19.25 21C19.25 21.6904 18.6904 22.25 18 22.25V23.75C19.5188 23.75 20.75 22.5188 20.75 21H19.25ZM18 1.75C18.6904 1.75 19.25 2.30964 19.25 3H20.75C20.75 1.48122 19.5188 0.25 18 0.25V1.75ZM6 0.25C4.48122 0.25 3.25 1.48122 3.25 3H4.75C4.75 2.30964 5.30964 1.75 6 1.75V0.25Z"
                                            fill="#0F2744" />
                                    </svg>
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="screenSize" id="Mobile" defaultValue="Mobile" onClick={() => setDeviceType('Mobile')} />
                                <label className="form-check-label" htmlFor="Mobile" title="Mobile">
                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM8 1.75H16V0.25H8V1.75ZM17.25 3V21H18.75V3H17.25ZM6.75 21V3H5.25V21H6.75ZM16 22.25H8V23.75H16V22.25ZM11 19.75H13V18.25H11V19.75ZM5.25 21C5.25 22.5188 6.48122 23.75 8 23.75V22.25C7.30964 22.25 6.75 21.6904 6.75 21H5.25ZM17.25 21C17.25 21.6904 16.6904 22.25 16 22.25V23.75C17.5188 23.75 18.75 22.5188 18.75 21H17.25ZM16 1.75C16.6904 1.75 17.25 2.30964 17.25 3H18.75C18.75 1.48122 17.5188 0.25 16 0.25V1.75ZM8 0.25C6.48122 0.25 5.25 1.48122 5.25 3H6.75C6.75 2.30964 7.30964 1.75 8 1.75V0.25Z"
                                            fill="#0F2744" />
                                    </svg>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="select-stage">
                        <div className="form-group">
                            <select className="form-control form-select" id="exampleFormControlSelect1" onChange={(e) => { onHandleChange(e) }}>
                            <option value="0">Select Stage</option>
                            {Object.keys(stage_array).map((key, index) => {
                                return (
                                    <option key={key} value={key}  selected={selectStage === key}>{stage_array[key]}</option>
                                )
                            })
                            }
                            </select>
                        </div>
                    </div>
                </div>
                </>
            )}
            <div className='center-align-iframe' style={deviceType == 'Mobile' ? { width: "360px" } : (deviceType == 'Tablet' ? { width: '768px' } : { width: '100%' })} >
                <div className="survey-preview">
                {reloadIframe && (
                    <iframe key={Math.random()} src={`${process.env.REACT_APP_USER_LINK}/report/${survey_id}/${stage_data}/${srid}/1`} width="100%" style={{ height: "100vh" }} frameBorder={0} />
                )}
                </div>
            </div>
        </>
    )
}